import axios from 'axios'
import { supabase } from '@/supabase'
import { runtimeConfig } from '@/config/runtimeEnv'

const httpClient = axios.create({
    baseURL: runtimeConfig.backendUrl,
})

httpClient.interceptors.request.use(async (config) => {
    const access_token = (await supabase.auth.getSession())?.data?.session?.access_token
    if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`
        if (!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json'
        }
    }
    return config
})

httpClient.interceptors.response.use(
    response => response,
    (error) => {
        if (!error.response) {
            return { status: 500 }
        }
        if (error.response.status >= 400 && error.response.status < 500) {
            console.log(error.response)
        }
        else if (error.response.status >= 500) {
            console.log(error.response)
        }
        return error.response
    },
)

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  page_size: number
}

export default httpClient
